var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18v1h7v-1H6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4Zm1.18 3c-.1 0-.18.06-.18.13v1.74c0 .07.08.13.18.13h8.64c.1 0 .18-.06.18-.13V5.13c0-.07-.08-.13-.18-.13H5.18ZM5 9.13c0-.07.08-.13.18-.13h8.64c.1 0 .18.06.18.13v1.74c0 .07-.08.13-.18.13H5.18c-.1 0-.18-.06-.18-.13V9.13ZM5.18 13c-.1 0-.18.06-.18.13v1.74c0 .07.08.13.18.13h8.64c.1 0 .18-.06.18-.13v-1.74c0-.07-.08-.13-.18-.13H5.18ZM5 17.2c0-.11.08-.2.18-.2h8.64c.1 0 .18.09.18.2v2.6c0 .11-.08.2-.18.2H5.18c-.1 0-.18-.09-.18-.2v-2.6Zm10-11c0-.11.02-.2.04-.2h1.92c.02 0 .04.09.04.2v2.6c0 .11-.02.2-.04.2h-1.92c-.02 0-.04-.09-.04-.2V6.2Zm.04 4.8c-.02 0-.04.09-.04.2v2.6c0 .11.02.2.04.2h1.92c.02 0 .04-.09.04-.2v-2.6c0-.11-.02-.2-.04-.2h-1.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default ForwardRef;